import { useAccountSubscriptionQuery } from "generated.hooks";
import useAuth from "hooks/useAuth";
import React, { createContext, useCallback } from "react";

type FeatureCode =
  | "livestream_telemetry"
  | "upload_data_logs"
  | "podium_app"
  | "send_pit_to_car_alerts"
  | "private_events"
  | "export_csv_data_logs"
  | "ai_coaching"
  | "rest_api";

const SubscriptionContext = createContext<{
  hasFeature: (featureCode: FeatureCode) => boolean;
  fetchAccountSubscription: () => void;
  isFreePlan: boolean;
  stripeRenewalFailed: boolean;
} | null>(null);

function SubscriptionContextProvider({ children }) {
  const { isSuperuser } = useAuth();
  const { data, refetch } = useAccountSubscriptionQuery({
    skip: isSuperuser,
  });

  const hasFeature = useCallback(
    (featureCode: string) => {
      return !!(
        data &&
        data.accountSubscription &&
        data.accountSubscription.subscriptionPlan.features.find(
          (f) => f.code === featureCode
        )
      );
    },
    [data]
  );

  return (
    <SubscriptionContext.Provider
      value={{
        hasFeature,
        fetchAccountSubscription: refetch,
        isFreePlan: !!(
          data &&
          data.accountSubscription &&
          data.accountSubscription.subscriptionPlan.name == "FREE"
        ),
        stripeRenewalFailed: !!data?.accountSubscription?.stripeRenewalFailed,
      }}
    >
      {children}
    </SubscriptionContext.Provider>
  );
}

export { SubscriptionContext, SubscriptionContextProvider };
